class ImageSplitView extends HTMLElement {
    constructor() {
        super();
        this.after = this.querySelector(".after-image");
        this.before = this.querySelector(".before-image");
        this.afterImage = this.querySelector(".after-image img");
        this.component = this.querySelector(".portal");
        this.split = this.querySelector(".split");
        this.control = this.querySelector(".control");
        this.svgIcon = this.querySelector("svg");
        this.onloadHandler = this.onload.bind(this);
        this.onChangeHandler = this.onChange.bind(this);
        this.onMouseMoveHandler = this.onMouseMove.bind(this);
        this.onMouseLeaveHandler = this.onMouseLeave.bind(this);
        this.onTouchStartHandler = this.onTouchStart.bind(this);
        window.addEventListener("DOMContentLoaded", this.onloadHandler);
        window.addEventListener("resize", this.onloadHandler);

        this.component.addEventListener("mousemove", this.onMouseMoveHandler);
        this.component.addEventListener("touchmove", this.onTouchStartHandler);
    }

    onload() {
        this.control.style.setProperty("--view-height", `${this.afterImage.clientHeight}px`);
        this.control.style.setProperty("--view-width", `${this.afterImage.clientWidth}px`);
    }

    onTouchStart(event) {
        const width = this.component.clientWidth;
        const currentOffsetX = event.touches[0].clientX;
        let currentPosition = Math.round((currentOffsetX * 100) / width);
        currentPosition = currentPosition >= 95 ? 95 : currentPosition <= 5 ? 5 : currentPosition;

        this.updateComponent(currentPosition);
    }

    onMouseMove(event) {
        if (this.lastPosition === event.offsetX) return;
        const width = this.component.clientWidth;
        const currentOffsetX = event.offsetX;
        let currentPosition = Math.round((currentOffsetX * 100) / width);
        currentPosition = currentPosition >= 97 ? 97 : currentPosition <= 2 ? 2 : currentPosition;

        this.updateComponent(currentPosition);

        this.addEventListener("mouseleave", this.onMouseLeaveHandler);
    }

    onMouseLeave(event) {
        this.lastPosition = event.offsetX;

        //this.component.removeEventListener("mousemove", this.onMouseMoveHandler);
    }

    updateComponent(position) {
        this.before.setAttribute("style", `--initial-value: 0 ${100 - position}% 0 0;`);
        this.svgIcon.setAttribute("style", `--left: ${position}%`);
        this.control.style.setProperty("--left", `${position}%`);
    }

    onChange() {
        if (parseInt(this.split.value) >= 2 || parseInt(this.split.value) <= 98) {
            this.before.setAttribute("style", `--initial-value: 0 ${100 - this.split.value}% 0 0;`);
            this.svgIcon.setAttribute("style", `--split: ${100 - this.split.value}%`);
        }
        if (parseInt(this.split.value) >= 95) {
            this.split.value = 95;
            this.before.setAttribute("style", `--initial-value: 0 ${100 - 95}% 0 0;`);
            this.svgIcon.setAttribute("style", `--split: ${100 - 95}%`);
        } else if (parseInt(this.split.value) <= 5) {
            this.split.value = 5;
            this.before.setAttribute("style", `--initial-value: 0 ${100 - 5}% 0 0;`);
            this.svgIcon.setAttribute("style", `--split: ${100 - 5}%`);
        }
    }
}

customElements.define("image-split-view", ImageSplitView);
